import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const MobileSeoSection = (): ReactElement => {
  const { t: tMobile } = useTranslation('', {
    keyPrefix: '$pages.$home.$mobileHomePage.$seoSection',
  });

  return (
    <div aria-label="Copy" className="seo-copy clearfix">
      <div className="clearfix">
        <h2 className="heading-flexbox" dangerouslySetInnerHTML={{ __html: tMobile('seoTitle') }} />
        <p>{tMobile('seoCopy')}</p>
        <span>
          <img
            src="/statics/img/mobile/renaissance-hotels-travels.webp"
            alt={tMobile('travelsImageAlt')}
            width={322}
            height={335}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
        </span>
      </div>
    </div>
  );
};

export default MobileSeoSection;
